import { DollarSign, FileText, Printer, TrendingUp } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const AnalyticsCards = ({ analytics, kiosks }) => {
  const activeKiosks = kiosks.filter(k => k.status === 'active').length;
  
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
      <Card data-testid="revenue-card">
        <CardHeader className="flex flex-row items-center justify-between pb-2">
          <CardTitle className="text-sm font-medium text-muted-foreground">
            Total Revenue
          </CardTitle>
          <DollarSign className="w-4 h-4 text-accent" />
        </CardHeader>
        <CardContent>
          <div className="text-3xl font-heading font-bold">
            ₹{analytics?.total_revenue || 0}
          </div>
          <p className="text-xs text-muted-foreground mt-1">
            Last {analytics?.period_days || 7} days
          </p>
        </CardContent>
      </Card>

      <Card data-testid="jobs-card">
        <CardHeader className="flex flex-row items-center justify-between pb-2">
          <CardTitle className="text-sm font-medium text-muted-foreground">
            Print Jobs
          </CardTitle>
          <FileText className="w-4 h-4 text-accent" />
        </CardHeader>
        <CardContent>
          <div className="text-3xl font-heading font-bold">
            {analytics?.total_jobs || 0}
          </div>
          <p className="text-xs text-muted-foreground mt-1">
            Total completed
          </p>
        </CardContent>
      </Card>

      <Card data-testid="kiosks-card">
        <CardHeader className="flex flex-row items-center justify-between pb-2">
          <CardTitle className="text-sm font-medium text-muted-foreground">
            Active Kiosks
          </CardTitle>
          <Printer className="w-4 h-4 text-accent" />
        </CardHeader>
        <CardContent>
          <div className="text-3xl font-heading font-bold">
            {activeKiosks}
          </div>
          <p className="text-xs text-muted-foreground mt-1">
            Out of {kiosks.length} total
          </p>
        </CardContent>
      </Card>

      <Card data-testid="avg-value-card">
        <CardHeader className="flex flex-row items-center justify-between pb-2">
          <CardTitle className="text-sm font-medium text-muted-foreground">
            Avg Job Value
          </CardTitle>
          <TrendingUp className="w-4 h-4 text-accent" />
        </CardHeader>
        <CardContent>
          <div className="text-3xl font-heading font-bold">
            ₹{analytics?.average_job_value || 0}
          </div>
          <p className="text-xs text-muted-foreground mt-1">
            Per transaction
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default AnalyticsCards;
